import React, { FC, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import StepAction from '../components/StepAction';
import { goToPrevStep, setCheckoutOverlay } from '../../../actions/ui';
import { getOrderTotal } from '../../../selectors/cart';
import { getMainEvent } from '../../../selectors/event';
import { isDynamicListing } from '@/selectors/dynamic-listing';
//import { navigate } from '@h/navigationService';
import { withRouterCompat } from '@h/withRouterCompat';
import { useNavigate } from 'react-router';

const StepActionContainer: FC = ({ disabled = false }: { disabled?: boolean}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const terminalId = useSelector((state: any) => state.payment.terminalId);
  const orderTotal = useSelector((state: any) => getOrderTotal(state).amount || 0);
  const currentStep = useSelector((state: any) => state.ui.currentStep);
  const steps = useSelector((state: any) => state.ui.listingConfig.checkoutSteps);
  const isSeries = useSelector((state: any) => !!getMainEvent(state)?.event?.isRecurring);
  const isDynamic = useSelector((state: any) => isDynamicListing(state));

  const handleBack = () => {
    if (currentStep === 0) {
      navigate(isSeries ? '/day' : '/');
      if (isDynamic) {
        dispatch(setCheckoutOverlay(false));
      }
    } else {
      dispatch(goToPrevStep());
    }
  }

  return (
    <StepAction
      firstStep={currentStep === 0}
      lastStep={currentStep === steps.length - 1}
      onBack={handleBack}
      orderTotal={orderTotal}
      terminalId={terminalId}
      disabled={disabled}
    />
  );
};

// export default withRouterCompat(StepActionContainer);
export default StepActionContainer;
